import React from 'react'
import CV from '../../assets/cv.pdf'

const CTA = () => {
  return (
    <div className='cta'>
        <a href={CV} download className='btn btn-third'>CV Herunterladen</a>
        <a href="#contact" className='btn btn-secondary'>Projekt besprechen</a>
    </div>
  )
}

export default CTA